export default __webpack_public_path__ + "static/media/kit_image2.e5f66b1d.png";